const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export type QuickRegistrationField = 'email' | 'code' | 'password' | 'consentOffer'
export type QuickRegistrationErrors = Partial<Record<QuickRegistrationField, string>>

export const hasQuickRegistrationErrors = (errors: QuickRegistrationErrors) =>
  Object.keys(errors).length > 0

export const validateQuickRegistrationEmail = (email: string): QuickRegistrationErrors => {
  if (!email.trim()) return { email: 'Введите email' }
  if (!EMAIL_RE.test(email.trim())) {
    return { email: 'Введите корректный email, например zakupki@company.ru' }
  }
  return {}
}

export const validateQuickRegistrationAccount = ({
  code,
  password,
  consentOffer,
}: {
  code: string
  password: string
  consentOffer: boolean
}): QuickRegistrationErrors => {
  const errors: QuickRegistrationErrors = {}
  if (!/^\d{6}$/.test(code.trim())) errors.code = 'Введите 6 цифр из письма'
  if (!password) errors.password = 'Введите пароль'
  else if (password.length < 8) errors.password = 'Пароль должен содержать не менее 8 символов'
  if (!consentOffer) errors.consentOffer = 'Нужно принять публичную оферту'
  return errors
}
